<template>
  <v-app>
    <v-app-bar app></v-app-bar>

    <v-main>
      <v-container>
        <v-card
          class="ma-auto"
          outlined
          style="
                  border-radius: 26px;
                  max-width: 800px
                "
        >
          <v-card-title>
            <span class="font-weight-light">LOG</span>
            <span class="red--text">IN</span>
            :THIRD PARTY PORTAL
          </v-card-title>

          <v-form class="ma-2 pa-2" @submit.prevent="onLogin">
            <v-expand-transition>
              <div>
                <v-card
                  style="
                          border-radius: 26px;
                          max-width: 500px;
                        "
                  outlined
                  tile
                  rounded
                  class="ma-auto"
                >
                  <v-text-field
                    label="EMAIL"
                    name="email"
                    validate-on-blur
                    required
                    id="email"
                    class="ma-2"
                    outlined
                    v-model="email"
                    autofocus
                    clearable
                    :rules="[rules.email]"
                    type="email"
                    shaped
                  ></v-text-field>
                  <!-- PASSWORD  -->
                  <v-text-field
                    label="PASSWORD"
                    name="password"
                    required
                    id="password"
                    class="ma-2"
                    outlined
                    v-model="password"
                    validate-on-blur
                    clearable
                    type="password"
                    :rules="[rules.length(6)]"
                    counter="6"
                  ></v-text-field>
                </v-card>
              </div>
            </v-expand-transition>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                rounded
                type="submit"
                class="mt-3"
                outlined
                color="primary"
              >
                LOGIN
                <template v-slot:loader>
                  <span class="custom-loader">
                    <v-icon light>cached</v-icon>
                  </span>
                </template>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn text @click="signUp" class="mt-3">
                <template>
                  <div>
                    <app-third-party-sign-up-dialog
                      :dialog="dialog"
                      @close="dialog = false"
                    ></app-third-party-sign-up-dialog>
                  </div>
                </template>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn text @click="sendResetEmail" class="mt-3"
                >reset password</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import firebase from "firebase";
export default {
  data: () => ({
    dialog: false,
    email: "",
    password: "",
    rules: {
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
      length: len => v =>
        (v || "").length >= len || `Invalid character length, required ${len}`
    }
  }),
  methods: {
    onLogin() {
      this.$store.dispatch("auth/login", {
        email: this.email,
        password: this.password
      });
    },
    signUp() {
      this.dialog = true;
    },
    sendResetEmail() {
      firebase
        .auth()
        .sendPasswordResetEmail(this.email)
        .then(() => {
          alert(`Reset Email Sent To: ${this.email}`);
        })
        .catch(e => {
          alert(`Error Code: ${e.code}, Error Message: ${e.message}`);
        });
    }
  },
  created() {
    console.log("ThirdPartyPortal.vue created");
  }
};
</script>

<style></style>
